var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 4.49984V3.83317C11.3333 2.89975 11.3333 2.43304 11.1517 2.07652C10.9919 1.76292 10.7369 1.50795 10.4233 1.34816C10.0668 1.1665 9.60009 1.1665 8.66667 1.1665H7.33333C6.39991 1.1665 5.9332 1.1665 5.57668 1.34816C5.26308 1.50795 5.00811 1.76292 4.84832 2.07652C4.66667 2.43304 4.66667 2.89975 4.66667 3.83317V4.49984M6.33333 9.08317V13.2498M9.66667 9.08317V13.2498M0.5 4.49984H15.5M13.8333 4.49984V13.8332C13.8333 15.2333 13.8333 15.9334 13.5609 16.4681C13.3212 16.9386 12.9387 17.321 12.4683 17.5607C11.9335 17.8332 11.2335 17.8332 9.83333 17.8332H6.16667C4.76654 17.8332 4.06647 17.8332 3.53169 17.5607C3.06129 17.321 2.67883 16.9386 2.43915 16.4681C2.16667 15.9334 2.16667 15.2333 2.16667 13.8332V4.49984",
    stroke: "#C9303D",
    strokeWidth: 0.856481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash_icon.0c0b6551d9e7bfe1b100f3bc0ca569fb.svg";
export { ForwardRef as ReactComponent };